import { render, staticRenderFns } from "./SearchSuggestionList.vue?vue&type=template&id=5ef2e880&"
import script from "./SearchSuggestionList.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports